export default __webpack_public_path__ + "static/media/banner1.d38edd30.svg";